import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PieChartData, PieOptions } from '@models/models';

@Component({
	selector: 'lead-sources-graph-section',
	template: require('./lead-sources-graph-section.component.html'),
	styles: [require('./lead-sources-graph-section.component.scss')]
})
export class LeadSourcesGraphSectionComponent implements OnInit {
	@Input() chartData: PieChartData;
	@Output() viewAllEmit: EventEmitter<void> = new EventEmitter<void>();
	pieOptions: PieOptions;

	constructor() {}

	ngOnInit(): void {
		this.setChartOptions();
	}

	viewAll(): void {
		this.viewAllEmit.emit();
	}

	private setChartOptions(): void {
		this.pieOptions = {
			legendRowLength: 3,
			pattern: 'NAME'
		};
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/dashboard/graphs-block/lead-sources-graph-section/lead-sources-graph-section.component.ts